import React from "react";
import { Button } from '../components/ui/Button';
import { Loader } from 'lucide-react';

function Confirmar({ 
  visible, 
  onConfirm, 
  onCancel, 
  mensaje,
  isLoading = false 
}: { 
  visible: boolean; 
  onConfirm: () => void; 
  onCancel: () => void; 
  mensaje: string;
  isLoading?: boolean;
}) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-primary bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-80 text-center">
        <h2 className="text-lg font-semibold mb-4 text-gray-800">
          CONFIRMAR ACCIÓN
        </h2>
        <p className="text-gray-700 mb-6">{mensaje}</p>
        <div className="flex justify-center gap-4">
          <Button 
            type="submit" 
            variant="primary" 
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader className="w-4 h-4 mr-2 animate-spin" />
                Guardando...
              </>
            ) : (
              'Guardar Cierre'
            )}
          </Button>
          <Button
            onClick={onCancel}
            type="button" 
            variant="ghost"
            disabled={isLoading}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Confirmar;